var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLineGraphics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 404,
    height: 296,
    viewBox: "0 0 404 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-bg-line-graphics"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 296
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg-line-graphics",
    clipPath: "url(#clip-bg-line-graphics)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(-153.617 -159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(491.919 -885.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(-336.302 1046.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M-7277.268,5051.063l-199.676-106.677-199.707,106.677,199.707,97.539Z",
    transform: "translate(7676.65 -4944.385)",
    fill: "none",
    stroke: "#ca9b3b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M-7277.268,5051.063l-199.676-106.677-199.707,106.677,199.707,97.539Z",
    transform: "translate(7676.65 -4903.414)",
    fill: "none",
    stroke: "#ca9b3b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M-7277.268,5051.063l-199.676-106.677-199.707,106.677,199.707,97.539Z",
    transform: "translate(7676.65 -4857.099)",
    fill: "none",
    stroke: "#ca9b3b",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLineGraphics);
export default __webpack_public_path__ + "static/media/bg-line-graphics.884573f05b7dff09e097eca74bf6ffa3.svg";
export { ForwardRef as ReactComponent };